module.exports = __webpack_public_path__ + "img/3.6d717ab5.png";